
/* injects from baggage-loader */

'use strict';

import PrivacyPolicyComponent from './privacy-policy.component';

const PrivacyPolicyPageModule = angular.module('privacy-policy-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('privacy-policy', {
        parent: 'root',
        url: '/legal/privacy-policy',
        title: 'Privacy Policy',
        component: 'privacyPolicy',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('privacyPolicy', new PrivacyPolicyComponent());

export default PrivacyPolicyPageModule;
